import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContact']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContact'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContact'])
    },
}